import { AufnahmePunktDocument } from "src/app/data-model";
import * as Substratfeuchte from '../../../assets/json/Substratfeuchte.json';
import { nWSKStufeEval } from "./nwsk";

export const substratfeuchteEval = (bp: any): string | undefined => {
	const b = bp as AufnahmePunktDocument;
	const s: any = Substratfeuchte;
	const st = nWSKStufeEval(bp);
	if (!st) return;
	const ws = () => {
		if (bp.extendedHeader.entwaesserungsverhalten === 'I') return 0;
		else if (bp.extendedHeader.entwaesserungsverhalten === 'II') return 1;
		else if (bp.extendedHeader.entwaesserungsverhalten === 'III') return 2;
		else return;
	};
	const wsIdx = ws();
	if (wsIdx === undefined) return;
	return s[st][wsIdx];
}
